import * as yup from 'yup';

const max_character_allowed = "500"

export const InspectionBookingValidationSchema = (t: any) => {
  return yup.object().shape({
    bookingDate: yup
      .string()
      .required(t('validation.required_field', 'This field is required')),
    remark: yup
      .string()
      .max(500, t('validation.max_characters', 'Maximum {max} characters allowed', { max: 500 }).replace("{max}", max_character_allowed))
      .nullable()
  });
};
